import React from 'react'
import {
  Wrapper,
  Title,
  CargoTitle,
  Info,
  Price,
  DriversInfo,
  Scale2RouteParts,
  PeriodicWrp,
} from '../../../smallPartsForInterface/SmallPartsWidgets'
import Icon from '../../../Icon'
import {
  NumberWithoutNulls,
  parseCargoInfo,
  KmWithoutNulls,
  parseExtraCarOption,
} from '../../../../lib/helpers/forRoutes'
import YellowMarker from '../../../YellowMarker'
import { currencyIcons } from '../../../../lib/constants'
import useRouter from '../../../../hooks/useRouter'
import { strToUpperCase } from '../../../../lib/helpers/forStyling'

export default ({ obj, dic }) => {
  const router = useRouter()
  const {
    defaultcurrency,
    budget,
    distance,
    routeparts,
    periodic,
    operator_relation,
    routeresponse_relation,
    routeresponse,
  } = obj

  const aboutDrivers = routeresponse_relation.find(
    (item) => item.id === routeresponse
  )
  return (
    obj &&
    dic && (
      <Wrapper isMrgnBtm onClick={() => router.push(`/route/${periodic}`)}>
        <div className="flexWrp" style={{ marginBottom: '1.5rem' }}>
          <Price>{`${strToUpperCase(dic.msg_10)}`}</Price>
        </div>
        <div className="flexWrp" style={{ marginBottom: '1.8rem' }}>
          {routeparts && (
            <Info isTrigerred>{`${dic.points} ${routeparts.length}`}</Info>
          )}
          {Boolean(obj.budget) && obj.budget > 1 && (
            <Info isTrigerred>{`${
              defaultcurrency
                ? currencyIcons[defaultcurrency]
                : currencyIcons.uah
            } ${NumberWithoutNulls(budget)}`}</Info>
          )}

          {Boolean(distance) && distance > 1 && (
            <Info isTrigerred>{`${KmWithoutNulls(distance)} ${dic.km}`}</Info>
          )}
        </div>
        <div style={{ marginBottom: '0.5rem' }}>
          <div className="flexWrp">
            {operator_relation && (
              <Title isMessage={false}>
                {operator_relation.company_relation.title_ru}
              </Title>
            )}
            {obj.needAttention && <YellowMarker />}
          </div>
          <Info className="flexWrp">
            <Icon name="hook" type="focused" style={{ marginTop: '0.4rem' }} />
            <CargoTitle style={{ textTransform: 'lowercase' }}>
              {parseCargoInfo(routeparts)}
            </CargoTitle>
          </Info>
          <Info style={{ paddingLeft: '1.35rem' }}>
            {parseExtraCarOption(obj)}
          </Info>
        </div>
        <Scale2RouteParts arr={routeparts} dic={dic} status="finish" />
        {aboutDrivers && <DriversInfo obj={aboutDrivers} />}
        <PeriodicWrp right>{`№ ${periodic}`}</PeriodicWrp>
      </Wrapper>
    )
  )
}
